import React from "react";
import { X } from "lucide-react";

const CloseStrike = ({
  t,
  selectedStrike,
  getStrikeCategoryLabel,
  closeStrikeForm,
  setCloseStrikeForm,
  closeStrikeErrors,
  setCloseStrikeErrors,
  closeStrikeLoading,
  onClose,
  onSubmit,
}) => (
  <div className="strike-modal-backdrop" role="presentation">
    <form className="strike-resolution-modal" onSubmit={onSubmit}>
      <div className="strike-resolution-header">
        <div>
          <h3>{t("applyStrike.history.closeModalTitle")}</h3>
          <p>{selectedStrike ? getStrikeCategoryLabel(selectedStrike.category) : "-"}</p>
        </div>
        <button type="button" className="strike-close-btn" onClick={onClose} aria-label={t("applyStrike.history.closeModal")}>
          <X size={18} />
        </button>
      </div>

      <div className="strike-field">
        <label className="strike-field-label" htmlFor="strike-resolution-reason">
          {t("applyStrike.history.resolutionReason")} <span className="strike-required">*</span>
        </label>
        <input
          id="strike-resolution-reason"
          className="strike-input"
          value={closeStrikeForm.resolution_reason}
          onChange={(event) => {
            setCloseStrikeForm((prev) => ({ ...prev, resolution_reason: event.target.value }));
            setCloseStrikeErrors((prev) => ({ ...prev, resolution_reason: "" }));
          }}
          placeholder={t("applyStrike.history.resolutionReasonPlaceholder")}
        />
        {closeStrikeErrors.resolution_reason ? (
          <span className="strike-error">{closeStrikeErrors.resolution_reason}</span>
        ) : null}
      </div>

      <div className="strike-field">
        <label className="strike-field-label" htmlFor="strike-resolution-notes">
          {t("applyStrike.history.resolutionNotes")} <span className="strike-required">*</span>
        </label>
        <textarea
          id="strike-resolution-notes"
          className="strike-textarea"
          rows="4"
          value={closeStrikeForm.resolution_notes}
          onChange={(event) => {
            setCloseStrikeForm((prev) => ({ ...prev, resolution_notes: event.target.value }));
            setCloseStrikeErrors((prev) => ({ ...prev, resolution_notes: "" }));
          }}
          placeholder={t("applyStrike.history.resolutionNotesPlaceholder")}
        />
        {closeStrikeErrors.resolution_notes ? (
          <span className="strike-error">{closeStrikeErrors.resolution_notes}</span>
        ) : null}
      </div>

      <div className="strike-resolution-actions">
        <button type="button" className="strike-btn-cancel" onClick={onClose} disabled={closeStrikeLoading}>
          {t("applyStrike.cancel")}
        </button>
        <button type="submit" className="strike-btn-submit" disabled={closeStrikeLoading}>
          {closeStrikeLoading ? t("applyStrike.history.closingStrike", "Closing...") : t("applyStrike.history.closeStrike")}
        </button>
      </div>
    </form>
  </div>
);

export default CloseStrike;
